import React from 'react'
import { Icon } from '@iconify/react';

const getTrendData = (current, previous) => {
    const diff = current - previous;
    const trend = diff >= 0 ? 'up' : 'down';
    return {
        trend,
        display: Math.abs(diff),
    };
};

const UserStatesCards = ({ states }) => {
    const {
        total_users,
        old_total_users,
        total_paid_users,
        old_total_paid_users,
        total_free_users,
        old_total_free_users,
        active_users,
        old_active_users,
        inactive_users,
        old_inactive_users,
        login_failed_users,
        old_login_failed_users,
    } = states || {};

    const totalUserTrend = getTrendData(total_users, old_total_users);
    const paidUserTrend = getTrendData(total_paid_users, old_total_paid_users);
    const freeUserTrend = getTrendData(total_free_users, old_total_free_users);
    const activeUserTrend = getTrendData(active_users, old_active_users);
    const inactiveUserTrend = getTrendData(inactive_users, old_inactive_users);
    const loginFailedTrend = getTrendData(login_failed_users, old_login_failed_users);

    return (
        <div className="row row-cols-xxxl-6 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
            {/* Total Users */}
            <StatCard
                title="Total Users"
                value={total_users}
                icon="gridicons:multiple-users"
                iconBg="bg-cyan"
                bgClass="bg-gradient-start-1"
                trend={totalUserTrend}
            />

            {/* Paid Users */}
            <StatCard
                title="Subscriber User"
                value={total_paid_users}
                icon="fa-solid:award"
                iconBg="bg-purple"
                bgClass="bg-gradient-start-2"
                trend={paidUserTrend}
            />

            {/* Free Users */}
            <StatCard
                title="Unsubscriber User"
                value={total_free_users}
                icon="fluent:people-20-filled"
                iconBg="bg-info"
                bgClass="bg-gradient-start-3"
                trend={freeUserTrend}
            />

            {/* Active Users */}
            <StatCard
                title="Active Users"
                value={active_users}
                icon="iconoir:activity"
                iconBg="bg-success-main"
                bgClass="bg-gradient-start-4"
                trend={activeUserTrend}
            />

            {/* Inactive Users */}
            <StatCard
                title="Inactive Users"
                value={inactive_users}
                icon="iconoir:cancel"
                iconBg="bg-red"
                bgClass="bg-gradient-start-5"
                trend={inactiveUserTrend}
            />

            {/* Login Failed Users */}
            <StatCard
                title="Login Failed Users"
                value={login_failed_users}
                icon="material-symbols:login-off-outline"
                iconBg="bg-red"
                bgClass="bg-gradient-start-5"
                trend={loginFailedTrend}
            />
        </div>
    );
};

const StatCard = ({ title, value, icon, iconBg, bgClass, trend }) => (
    <div className="col">
        <div className={`card shadow-none border ${bgClass} h-100`}>
            <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div>
                        <p className="fw-medium text-primary-light mb-1">{title}</p>
                        <h6 className="mb-0">{value}</h6>
                    </div>
                    <div className={`w-50-px h-50-px ${iconBg} rounded-circle d-flex justify-content-center align-items-center`}>
                        <Icon icon={icon} className="text-white text-2xl mb-0" />
                    </div>
                </div>
                <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                    <span className={`d-inline-flex align-items-center gap-1 ${trend.trend === 'up' ? 'text-success-main' : 'text-danger-main'}`}>
                        <Icon icon={`bxs:${trend.trend}-arrow`} className="text-xs" />
                        {trend.trend === 'up' ? '+' : '-'}{trend.display}
                    </span>
                    vs last period
                </p>
            </div>
        </div>
    </div>
);

export default UserStatesCards;
